/*
 * @ts-nocheck
 * Exportujeme vsetko, co budeme potrebovat v inych castiach hry
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { minigameConfig } from '.';
import { TimeManager } from '@powerplay/time-system';
import { GameStats, FpsManager } from '@powerplay/stats-system';
import { ParticleSystem, ParticleManager } from '@powerplay/particle-system';
import { CorePhasesManager } from '@powerplay/phases-system';
import { PlayersManager } from '@powerplay/players-system';
import { Game3DManager } from '@powerplay/game3d-system';
import { RequestManager } from '@powerplay/request-system';
import { Settings } from '@powerplay/settings';
import { Translations } from '@powerplay/translation-system';
import { TutorialManager } from '@powerplay/tutorial-system';
import { AudioManager } from '@powerplay/audio-system';
import { CameraManager } from '@powerplay/camera-system';
import { InputsManager } from '@powerplay/inputs-system';
import { TrainingManager } from '@powerplay/training-system';
export * from '@powerplay/animations-system';
export * from '@powerplay/audio-system';
export * from '@powerplay/camera-system';
export * from '@powerplay/common';
export * from '@powerplay/game3d-system';
export * from '@powerplay/generator-system';
export * from '@powerplay/initializer';
export * from '@powerplay/inputs-system';
export * from '@powerplay/loading-system';
export * from '@powerplay/particle-system';
export * from '@powerplay/phases-system';
export * from '@powerplay/physics';
export * from '@powerplay/players-system';
export * from '@powerplay/request-system';
export * from '@powerplay/settings';
export * from '@powerplay/stats-system';
export * from '@powerplay/time-system';
export * from '@powerplay/training-system';
export * from '@powerplay/translation-system';
export * from '@powerplay/tutorial-system';
export * from './types';
export * from './config';
export { MainCore } from './MainCore';
const gameStats = new GameStats();
const requestManager = new RequestManager();
const settings = new Settings(requestManager.sendSaveSettingsRequest);
const fpsManager = new FpsManager(settings, minigameConfig.fpsLimit);
const cameraManager = new CameraManager();
const tutorialManager = new TutorialManager();
const inputsManager = new InputsManager(() => {
    tutorialManager.actionPressed();
});
const timeManager = new TimeManager(fpsManager.fpsLimit);
const audioManager = new AudioManager();
const translations = new Translations();
const trainingManager = new TrainingManager(requestManager.sendSaveBetweenResultsRequest);
const particleManager = new ParticleManager(new ParticleSystem());
const corePhasesManager = new CorePhasesManager(cameraManager, inputsManager, fpsManager, settings, gameStats, trainingManager, requestManager);
const game = new Game3DManager(particleManager, timeManager, corePhasesManager, audioManager, settings, fpsManager, cameraManager, inputsManager);
const playersManager = new PlayersManager(corePhasesManager, minigameConfig.dnfValue, minigameConfig.dnsValueDescending, minigameConfig.dnsValueAscending, minigameConfig.dsqValue, minigameConfig.maxTimestamp, minigameConfig.fpsLimit);
export { game, timeManager, requestManager, audioManager, tutorialManager, translations, corePhasesManager, playersManager, settings, gameStats, particleManager, fpsManager, inputsManager, cameraManager, trainingManager };
//# sourceMappingURL=index.js.map